
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {rules} from "@/auxillary/rules";
import VisitContextCache from "@/models/visit.context.cache";
import {currentUserModule, rolesModule, visitModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import VisitSignatureDto = MdbsCore.VisitSignatureDto;
import IVisitSignatureDto = MdbsCore.IVisitSignatureDto;

@Component({})
export default class SignatureDialog extends Vue {
  @Prop({required: true})
  visit: VisitContextCache | null;

  @Prop({required: true})
  dialogVisible: boolean | null;

  private reason = "Ich bestätige hiermit die Richtigkeit der Daten.";
  private userName = "";
  private password = "";

  saving = false;
  valid: boolean = false;
  rules: any = rules;

  get loading() {
    return false;
  }

  @Watch('visit', {immediate: true})
  async onVisitChange(visit: VisitContextCache | null) {
    if (visit == null) {
      return;
    }

    Vue.nextTick(() => {
      this.form?.validate();
    });
  }

  @Watch('dialogVisible', {immediate: true})
  async onDialogVisibleChange(visible: boolean) {
    if (!visible) return;

    await this.prePopulateUserName();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  async save() {
    if (!this.visit) return;

    try {
      this.saving = true;

      const signatureData: IVisitSignatureDto = new VisitSignatureDto({
        reason: this.reason,
        userName: this.userName,
        password: this.password
      });
      await visitModule.sign({visitId: this.visit.id, signatureData: signatureData});

      this.$emit('save');
    } finally {
      this.saving = false;
      this.userName = "";
      this.password = "";
    }
  }

  async cancel() {
    this.$emit('cancel');
    this.userName = "";
    this.password = "";
  }

  get currentUser() {
    return currentUserModule.user;
  }

  async mounted() {
  }

  private async prePopulateUserName() {
    const user = this.currentUser;
    if (user?.role?.id == null || user?.userName == null) return;

    if(currentUserModule.isNtdUser)
      return;

    const role = await rolesModule.getRoleById(user.role.id);

    if (role?.identifier?.toLowerCase() == "physician") {
      this.userName = user.userName;
    }
  }
}
